import React, { Fragment } from 'react'
import styled from 'styled-components'

const ApiWrapper = ({ attributes, children, element, editor }) => <Api {...attributes}>{children}</Api>

export default ApiWrapper

const Api = styled.div`
  margin: 15px 0px;
`
